import React, { Component } from 'react';
import {Link} from 'react-router';

export default class TopSummary extends Component {

  state = {
    counter: 0
  };

  timer = null;

  callTimer () {
    this.timer = setTimeout(
      () => {
        this.setState({
          counter: this.state.counter + 1
        });
        this.callTimer();
      },
      8000
    );
  }

  componentDidMount () {
    this.callTimer();
  }

  componentWillUnmount () {
    clearTimeout(this.timer);
    this.timer = null;
  }

  render() {
    const {testimonials} = this.props;
    const testimonial = testimonials[this.state.counter % testimonials.length];
    return (
      <div id="topsummary">
        <blockquote className="testimonial">
          <Link to="/testimonials" title="Read more customer testimonials">
            {testimonial.extract}
          </Link>
        </blockquote>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/TopSummary.js
 **/